import { createGetContractBasedDataFetchSlice } from '@cp-shared-10/frontend-integration';
import { CpDataApi } from 'cp-xhr';
import { DefaultBusinessMarketApiErrorCode } from '@cp-shared-10/common-utilities';
import { PaymentOverviewDetails } from 'common';

const { reducer, fetchData } = createGetContractBasedDataFetchSlice<
    PaymentOverviewDetails[],
    DefaultBusinessMarketApiErrorCode
>({
    dataName: 'paymentOverview',
    fetchCallback(link: string) {
        return CpDataApi.get(link).then((response) => response.data);
    },
});

export default reducer;
export const fetchPaymentOverview = fetchData;
